
import React from 'react';
import { CheckCircle } from 'lucide-react';

const GovernanceStatus = () => {
  return (
    <div className="text-sm">
      <h3 className="text-white font-medium mb-2">Governance Status</h3>
      <ul className="space-y-1 mb-4">
        <li className="flex items-center">
          <CheckCircle className="h-4 w-4 mr-2 text-green-500" />
          <span className="text-gray-300">Data Classification</span>
        </li>
        <li className="flex items-center">
          <CheckCircle className="h-4 w-4 mr-2 text-green-500" />
          <span className="text-gray-300">External access</span>
        </li>
        <li className="flex items-center">
          <CheckCircle className="h-4 w-4 mr-2 text-green-500" />
          <span className="text-gray-300">Retention Policy</span>
        </li>
      </ul>
    </div>
  );
};

export default GovernanceStatus;
